module.exports = __webpack_public_path__ + "static/img/1_6_2.b457d583.jpg";